import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import * as Auth from "aws-amplify/auth";
import * as amplifyStorage from "aws-amplify/storage";
import nacl from "tweetnacl";
import { KMSClient, EncryptCommand, DecryptCommand } from "@aws-sdk/client-kms";
// @ts-expect-error TS(7016): Could not find a declaration file for module 'json... Remove this comment to see the full error message
import jsonld from "jsonld";
// @ts-expect-error TS(7016): Could not find a declaration file for module 'rdf-... Remove this comment to see the full error message
import rdfCanonize from "rdf-canonize";
import { VcSdkError } from "@swiss-digital-assets-institute/vc-sdk-js-common-types";
import {
  ProofPurpose,
  ProofType,
} from "@swiss-digital-assets-institute/vc-sdk-js-proof";
import { KeysUtility, Verifier } from "@swiss-digital-assets-institute/core";
import { PrivateKey, PublicKey } from "@hashgraph/sdk";
import forge from "node-forge";
import { GET_PUBLIC_KEY, GET_TEMPLATE_BY_ID } from "services/ApiServices";
import moment from "moment";
import * as changeCase from "change-case";
import { VP_RESULT } from "./contants";
import * as crypto from "crypto";

export const S3_USER_STORAGE_PREFIX = `user_folders`;

export const getErrorString = (
  e: any,
  defaultErrorText = "Something went wrong!"
) => {
  if (e && e.error && e.error.message && typeof e.error.message === "string") {
    return e.error.message;
  }
  const errorString =
    e.response &&
    e.response.data &&
    e.response.data.message &&
    typeof e.response.data.message === "string"
      ? e.response.data.message
      : e.message && typeof e.message === "string"
        ? e.message
        : typeof e === "string"
          ? e
          : defaultErrorText;
  return errorString;
};

export function validateArrayOfObjects(arr: any) {
  if (!Array.isArray(arr)) {
    return false;
  }

  return arr.every((obj) => {
    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      return false;
    }

    return Object.values(obj).every((value) => {
      if (typeof value === "string") {
        return value.trim() !== ""; // Check if the string is not empty after trimming whitespace
      } else if (value === null || typeof value === "undefined") {
        return false;
      }

      return true;
    });
  });
}

export const serialize = (params: any) => {
  var str = [];
  for (var p in params)
    if (params.hasOwnProperty(p) && params[p].toString()) {
      if (Array.isArray(params[p])) {
        console.log("Params", params[p]);
        str.push(
          encodeURIComponent(p) +
            "=" +
            encodeURIComponent(JSON.stringify(params[p]))
        );
      } else {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(params[p]));
      }
    }
  return str.join("&");
};

export const DURATION_DROPDOWN_OPTIONS = (() => {
  const currentDate = new Date();
  return {
    "7_DAYS": {
      label: "7 days",
      value: currentDate.getDate() - 6,
    },
    "15_DAYS": {
      label: "15 days",
      value: currentDate.getDate() - 14,
    },
    "30_DAYS": {
      label: "30 days",
      value: currentDate.getDate() - 29,
    },
    "3_MONTHS": {
      label: "3 months",
      value: currentDate.getMonth() - 3,
    },
    LAST_YEAR: {
      label: "last year",
      value: currentDate.getDate() - 364,
    },
  };
})();

export const TEMPLATE_ATTRIBUTE_OPTIONS = [
  { label: "Text", value: "Text" },
  { label: "Number", value: "Number" },
  { label: "Yes/No", value: "Yes/No" },
  { label: "URL", value: "URL" },
  { label: "Date", value: "Date" },
  { label: "Date-Time", value: "Date-Time" },
];

export const VP_REQUEST_STATUS = (requestStatus: any) => {
  switch (requestStatus) {
    case "requestSent":
      return "Request Sent";
    case "documentReceived":
      return "Document Received";
    case "requestRejected":
      return "Request Rejected";
    default:
      return "-";
  }
};

export const ISSUE_PREVIEW_STATIC_FIELDS = (fieldName: any) => {
  switch (fieldName) {
    case "expiryDate":
      return "Expiry Date";
    case "expireCredential":
      return "Expire Credential";
    case "isRevocable":
      return "Is Revocable";
    case "issueDate":
      return "Issue Date";
    default:
      return fieldName;
  }
};

/**
 *
 * @param {*} data Data to write to excel
 * @param {*} fileName File name
 * @returns Success as a boolean
 */
export const saveDataToExcelAndDownload = async (data: any, fileName: any) => {
  const { utils, write } = await import("sheetjs-style");
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const isValidData = (data: any) => {
    if (Array.isArray(data)) {
      if (data.length === 0) {
        return false;
      }
      return data;
    } else {
      if (!data) {
        return false;
      }
      if (typeof data === "object") {
        if (Object.entries(data).length === 0) {
          return false;
        }
      }
      return [data];
    }
  };

  const finalData = isValidData(data);

  if (!finalData) {
    toast.error("Cannot generate report for empty data!");
    return false;
  }

  const ws = utils.json_to_sheet(finalData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: fileType });
  saveAs(blob, fileName + fileExtension);
  return true;
};
/**
 *
 * @param {*} milliseconds milliseconds for timeout
 * @returns Promise
 */
export const sleep = (milliseconds: any) =>
  new Promise((resolve) => setTimeout(resolve, milliseconds));

export function camelCaseToDisplayString(inputString: any) {
  // Use a regular expression to split the string at each capital letter
  // and add a space before each capital letter.
  if (!inputString) {
    return;
  }
  return (
    inputString
      .replace(/([A-Z])/g, " $1")
      // Capitalize the first letter and remove leading spaces
      .replace(/^./, (str: any) => str.toUpperCase())
      .trim()
  );
}

export async function createFileFrom(url: any) {
  const response = await fetch(url, {
    mode: "no-cors",
  });
  const data = await response.blob();
  const metadata = {
    type: "image/jpeg",
  };
  const file = new File([data], "test.jpg", metadata);
  return file;
}

/**
 * Returns results after uploading data to cloud.
 *
 * @param {Object} params with data and folderPath keys.
 * @param {string} params.data The data string to be uploaded.
 * @param {string} params.folderPath one of 'nearWallet/keypair.txt', 'userDid/keypair.txt', 'userVcs/vcs.txt'.
 * @return {any} result.
 */
export const uploadUserDataToCloud = async ({ data, folderPath }: any) => {
  const dataAsString = data;

  // @ts-expect-error TS(2339): Property 'encryptedData' does not exist on type '{... Remove this comment to see the full error message
  const { encryptedData, dbUserId } = await encryptDataWithKMS(dataAsString);

  const result = await amplifyStorage.uploadData({
    key: S3_USER_STORAGE_PREFIX + `/${dbUserId}/` + folderPath,
    data: encryptedData,
    options: {
      accessLevel: "private",
      contentType: "plain/text",
    },
  });
  console.log("result:: ", result);
  return result;
};

/**
 * Returns text after downloading data from cloud.
 * @param {Object} params with folderPath keys.
 * @param {string} params.folderPath one of 'nearWallet/keypair.txt', 'userDid/keypair.txt', 'userVcs/vcs.txt'.
 * @return {string} text.
 */
export const getUserDataFromCloud = async ({ folderPath }: any) => {
  const user = await Auth.fetchAuthSession();
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const dbUserId = user.tokens.idToken.payload["custom:dbUserId"];
  const downloadResult = await amplifyStorage.downloadData({
    key: S3_USER_STORAGE_PREFIX + `/${dbUserId}/` + folderPath,
    options: {
      accessLevel: "private",
    },
  }).result;
  const text = await downloadResult.body.text();
  const data = await decryptDataWithKms(text, user);
  return data;
};

export const generateKeys = () => {
  const keyPair = nacl.box.keyPair();
  return {
    publicKey: toHex(keyPair.publicKey),
    privateKey: toHex(keyPair.secretKey),
  };
};

const toHex = (buffer: any) =>
  (buffer instanceof Buffer ? buffer : Buffer.from(buffer)).toString("hex");

const fromHex = (hex: any) => {
  const buffer = Buffer.from(hex, "hex");
  return new Uint8Array(buffer);
};

export const generateNonce = () => {
  return new Uint8Array(nacl.randomBytes(nacl.box.nonceLength));
};

export const establishSharedSecret = (
  otherPartyPublicKey: any,
  privateKey: any
) => {
  const sharedSecret = nacl.box.before(
    fromHex(otherPartyPublicKey),
    fromHex(privateKey)
  );

  return Buffer.from(sharedSecret).toString("hex");
};

export const encryptMessage = (sharedSecret: any, message: any) => {
  const nonce = generateNonce();
  const messagePayload = new Uint8Array(Buffer.from(message, "utf-8"));
  const encryptedMessage = nacl.secretbox(
    messagePayload,
    nonce,
    fromHex(sharedSecret)
  );

  return {
    cipherText: toHex(encryptedMessage),
    nonce: toHex(nonce),
  };
};

export const decryptMessage = (
  sharedSecret: any,
  nonce: any,
  cipherText: any
) => {
  if (!sharedSecret || !nonce || !cipherText) {
    return "";
  }
  const decryptedMessage = nacl.secretbox.open(
    fromHex(cipherText),
    fromHex(nonce),
    fromHex(sharedSecret)
  );

  if (!decryptedMessage) {
    return "";
  }

  return Buffer.from(decryptedMessage).toString("utf-8");
};

export const fetchKmsKey = async () => {
  try {
    const user = await Auth.fetchAuthSession();
    console.log("User:::", JSON.stringify(user));

    const kmsKeyId = user.tokens?.idToken?.payload["custom:kmsKey"]; // Fetch KMS Key from Cognito
    return kmsKeyId;
  } catch (error) {
    console.error("Error fetching KMS key:", error);
  }
};

//This Function is for Issuer and Verifier
export const downloadAdminDataFromCloud = async ({ folderPath }: any) => {
  try {
    const userSession = await Auth.fetchAuthSession();
    const adminId = userSession.tokens?.idToken?.payload["custom:adminId"];
    const adminIdentityId =
      userSession.tokens?.idToken?.payload["custom:adminIdentityId"];
    const downloadResult = await amplifyStorage.downloadData({
      path:
        "private/" +
        adminIdentityId +
        "/user_folders" +
        `/${adminId}/` +
        folderPath,
      options: {},
    }).result;
    const data = await downloadResult.body.text();
    return await decryptDataWithKms(data, userSession);
  } catch (err) {
    console.log(err, "downloadAdminDataFromCloud");
  }
};

export const decryptDataWithKms = async (data: any, userSession: any) => {
  // console.log("response::", text);
  const kmsId = userSession.tokens?.idToken?.payload["custom:kmsKey"];
  const client = new KMSClient({
    region: "ap-south-1",
    credentials: userSession.credentials,
  });
  const decryptCommand = new DecryptCommand({
    EncryptionAlgorithm: "RSAES_OAEP_SHA_256",
    CiphertextBlob: Buffer.from(data, "base64"),
    KeyId: kmsId,
  });

  try {
    const data = await client.send(decryptCommand);
    const value = data.Plaintext;

    // @ts-expect-error TS(2461): Type 'Uint8Array | undefined' is not an array type... Remove this comment to see the full error message
    return data.Plaintext && JSON.parse(String.fromCharCode(...value));
  } catch (error) {
    console.error("Error decrypting data:", error);
    throw error;
  }
};

export const encryptDataWithKMS = async (data: any) => {
  const userSession = await Auth.fetchAuthSession();
  // @ts-expect-error TS(2532): Object is possibly 'undefined'.
  const dbUserId = userSession.tokens.idToken.payload["custom:dbUserId"];
  const kmsId = userSession.tokens?.idToken?.payload["custom:kmsKey"];
  const credentials = userSession.credentials;
  const client = new KMSClient({ region: "ap-south-1", credentials });
  const params = {
    KeyId: kmsId,
    Plaintext: Buffer.from(data),
  };

  const command = new EncryptCommand({
    EncryptionAlgorithm: "RSAES_OAEP_SHA_256",
    ...params,
    KeyId: params.KeyId as string,
  });
  try {
    const response = await client.send(command);
    const encryptedData =
      response.CiphertextBlob &&
      Buffer.from(response.CiphertextBlob).toString("base64");

    console.log(
      "user data:::",
      JSON.stringify(userSession.tokens?.idToken?.payload)
    );

    return { encryptedData, dbUserId };
  } catch (error) {
    console.error("Error encrypting data:", error);
    return null;
  }
};

export function hashContent(content: any, hashMethod = "sha256") {
  const contentString =
    typeof content === "object" ? JSON.stringify(content) : content;
  const hash = crypto
    .createHash(hashMethod)
    .update(contentString)
    .digest("hex");
  return { hash, hashMethod };
}

export function checkHash(hash: any, hashMethod: any, content: any) {
  const contentString =
    typeof content === "object" ? JSON.stringify(content) : content;
  const { hash: computedHash, hashMethod: computedHashMethod } = hashContent(
    contentString,
    hashMethod
  );

  return hash === computedHash && hashMethod === computedHashMethod;
}

export const getCustomLoader = (urlHashes: any) => {
  return async (url: any) => {
    const response = await fetch(url);

    if (!response.ok) {
      throw new VcSdkCanonicalizerError(`Failed to load context: ${url}`);
    }

    const contextData = await response.text();

    if (urlHashes[url]) {
      if (!checkHash(urlHashes[url], "sha256", contextData)) {
        console.error(`Context integrity check failed for: ${url}`);
        throw new VcSdkCanonicalizerError(
          `Context integrity check failed for: ${url}`
        );
      }
    }

    return {
      contextUrl: null, // this is for a context via a link header
      document: JSON.parse(contextData), // the actual document that was loaded
      documentUrl: url, // the actual context URL after redirects
    };
  };
};

export const canonize = async (content: any, urlHashes: any) => {
  try {
    jsonld.documentLoader = getCustomLoader(urlHashes);
    const nquads = await jsonld
      .toRDF(content, { format: "application/n-quads" })
      .catch((error: any) => {
        if (error?.details?.cause instanceof VcSdkError) {
          throw error.details.cause;
        }

        throw error;
      });

    const parsedQuads = rdfCanonize.NQuads.parse(nquads);

    for (const quad of parsedQuads) {
      if (!quad.subject || !quad.predicate || !quad.object) {
        console.error("Invalid quad detected:", quad);
        throw new VcSdkCanonicalizerError(
          "Detected invalid quad with missing terms."
        );
      }
    }
    const canonical = await rdfCanonize.canonize(parsedQuads, {
      algorithm: "RDFC-1.0",
    });

    return canonical;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const signWithUserDidKeypair = async (messageToBeSigned: any) => {
  const keyPair = await downloadAdminDataFromCloud({
    folderPath: "userDid/keypair.txt",
  });
  const privateKey = PrivateKey.fromStringDer(keyPair.privateKey);
  const message = Buffer.from(messageToBeSigned);
  const signature = privateKey.sign(message);

  return signature;
};

export const createProof = async (
  document: any,
  { withDidResolution = true, ...options },
  did: any
) => {
  const canonicalizedCredential = await canonize(
    document,
    options.contextHashes
  );

  if (!did) {
    throw new VcSdkProofError("No did provided");
  }

  const proofValue = await signWithUserDidKeypair(canonicalizedCredential);
  const proofValueMultibase = KeysUtility.fromBytes(proofValue).toMultibase();

  const proof = {
    type: ProofType.Ed25519Signature2020,
    proofPurpose: ProofPurpose.AssertionMethod,
    created: new Date().toISOString(),
    verificationMethod: `${did}#did-root-key`,
    proofValue: proofValueMultibase,
    ...(options.challenge && { challenge: options.challenge }),
  };

  return proof;
};

export function getPublicKeyFromIssuerDID(did: any) {
  // Split the DID string to extract the multibase-encoded public key
  try {
    const parts = did.split("_");
    const pubKeyMultiBase = parts[0].split(":").pop();
    const publicKey = KeysUtility.fromMultibase(pubKeyMultiBase).toPublicKey();

    return publicKey;
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
}

export const verifyProof = async (
  document: any,
  proof: any,
  { customTopicReader = undefined, ...options },
  pubKey: any
) => {
  try {
    let message;
    if (
      options.processDataForProofVerification &&
      typeof options.processDataForProofVerification === "function"
    ) {
      message = await options.processDataForProofVerification({
        ...document,
        proof,
      });
    } else {
      // Compose and encode message (canonicalized document)
      const canonicalizedCredential = await canonize(
        document,
        options.contextHashes
      );
      const encoder = new TextEncoder();
      message = encoder.encode(canonicalizedCredential);
    }
    // Check mandatory proof fields
    const { type, verificationMethod, proofPurpose, proofValue } = proof;
    if (!verificationMethod || !type || !proofPurpose) {
      return {
        verified: false,
        errors: [
          'Missing required "verificationMethod", "type", or "proofPurpose" field',
        ],
      };
    }

    // Check matches for proof purpose, challenge and domain
    if (
      options.expectedProofPurpose &&
      options.expectedProofPurpose !== proof.proofPurpose
    ) {
      return { verified: false, errors: ["Proof purpose mismatch"] };
    }

    if (options.challenge && options.challenge !== proof.challenge) {
      return { verified: false, errors: ["Proof challenge mismatch"] };
    }

    if (options.domain) {
      const proofDomains = Array.isArray(proof.domain)
        ? proof.domain
        : [proof.domain];
      const inputDomains = Array.isArray(options.domain)
        ? options.domain
        : [options.domain];
      if (!inputDomains.every((domain) => proofDomains.includes(domain))) {
        return { verified: false, errors: ["Proof domain mismatch"] };
      }
    }

    const proofValueUint8Array =
      KeysUtility.fromMultibase(proofValue).toBytes();
    const keyPair = PublicKey.fromStringED25519(pubKey);
    const verified = keyPair.verify(message, proofValueUint8Array);

    if (!verified) {
      return {
        verified: false,
        errors: [
          "Invalid proof: Proof value does not match the expected signature",
        ],
      };
    }

    return { verified: true, verifiedDocument: document, errors: [] };
  } catch (error) {
    console.log(error, "::::::verifyProof");
    return {
      verified: false,
      errors: [
        `Invalid proof: ${error instanceof Error ? error?.message : "Unknown error"}`,
      ],
    };
  }
};

export class VcSdkCanonicalizerError extends VcSdkError {}
export class VcSdkProofError extends VcSdkError {}

export const vpResultData = (row: any) => {
  const showViewIcon = [
    VP_RESULT.ACCEPTED,
    VP_RESULT.VERIFIED,
    VP_RESULT.PARTIAL_VERIFIED,
    VP_RESULT.INVALID,
    VP_RESULT.PARTIAL_ACCEPTED,
  ].includes(row);

  const data = [
    "Verified",
    "verified",
    "verifiedCount",
    VP_RESULT.VERIFIED,
  ].includes(row)
    ? {
        primary: "#16A34A", // Green 600
        secondary: "#86EFAC", // Green 300
        name: "Verified",
        color: "text-green-600",
        key: row,
      }
    : [
          "PartialVerified",
          "partialVerified",
          "partialVerifiedCount",
          VP_RESULT.PARTIAL_VERIFIED,
        ].includes(row)
      ? {
          primary: "#F59E0B", // Amber 600
          secondary: "#FDE68A", // Amber 300
          name: "Partial Verified",
          color: "text-amber-600",
          key: row,
        }
      : ["Accepted", "accepted", "acceptedCount", VP_RESULT.ACCEPTED].includes(
            row
          )
        ? {
            primary: "#2563EB", // Blue 600
            secondary: "#93C5FD", // Blue 300
            name: "Accepted",
            color: "text-blue-600",
            key: row,
          }
        : [
              "PartialAccepted",

              "partialAccepted",
              "partialAcceptedCount",
            ].includes(row)
          ? {
              primary: "#D97706", // Orange 600
              secondary: "#FDBA74", // Orange 300
              name: "Partial Accepted",
              color: "text-orange-600",
              key: row,
            }
          : ["Pending", "pending", "pendingCount", VP_RESULT.PENDING].includes(
                row
              )
            ? {
                primary: "#EAB308", // Yellow 600
                secondary: "#FACC15", // Yellow 400
                name: "Pending",
                color: "text-yellow-600",
                key: row,
              }
            : [
                  "Invalid",
                  "invalid",
                  "invalidCount",
                  VP_RESULT.INVALID,
                ].includes(row)
              ? {
                  primary: "#EF4444", // Red 500
                  secondary: "#FCA5A5", // Red 300
                  name: "Invalid",
                  color: "text-red-500",
                  key: row,
                }
              : [
                    "rejectedCount",
                    "rejected",
                    "Rejected",
                    VP_RESULT.REJECTED,
                  ]?.includes(row)
                ? {
                    primary: "#DC2626", // Red 600
                    secondary: "#F87171", // Red 400
                    name: "Rejected",
                    color: "text-red-600",
                    key: row,
                  }
                : [
                      "NotFound",
                      "notFound",
                      "notFoundCount",
                      VP_RESULT.NOT_FOUND,
                    ].includes(row)
                  ? {
                      primary: "#F43F5E", // Rose 500 (Radish-like)
                      secondary: "#FECDD3", // Rose 200
                      name: "Not Found",
                      color: "text-rose-500",
                      key: row,
                    }
                  : { primary: "#6B7280", secondary: "#9CA3AF", key: row };
  return { showViewIcon, data };
};

export const changeVpKey = (data: any) => {
  const keys = Object.keys(data);
  const newData = {};
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  keys.map((item) => (newData[`${vpResultData(item).data.key}`] = data[item]));
  return newData;
};

export function validateImageMagicNumber(file: any) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = (e) => {
      if (!reader.result || typeof reader.result === "string") {
        throw new Error("File reading failed - unexpected result type");
      }
      const arr = new Uint8Array(reader.result).subarray(0, 4);
      let header = "";
      for (let i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }

      // JPEG: starts with ffd8ffe0 or ffd8ffe1
      // PNG: starts with 89504e47
      const isValid =
        header.startsWith("89504e47") || // PNG
        header.startsWith("ffd8ffe0") || // JPEG
        header.startsWith("ffd8ffe1") ||
        header.startsWith("ffd8ffe2");

      resolve(isValid);
    };
    reader.readAsArrayBuffer(file.slice(0, 4));
  });
}

export const handleAttributeType = (attributeType: any) => {
  return {
    type: [
      "Text",
      "string",
      "Date",
      "Date-Time",
      "date",
      "date-time",
      "url",
      "URL",
      "uri",
    ].includes(attributeType)
      ? "string"
      : ["Yes/No", "boolean"].includes(attributeType)
        ? "boolean"
        : ["Number", "number"].includes(attributeType)
          ? "number"
          : attributeType,
    format: ["Date", "date"].includes(attributeType)
      ? "date"
      : ["Date-Time", "date-time"].includes(attributeType)
        ? "date-time"
        : ["URL", "url", "uri"].includes(attributeType)
          ? "uri"
          : undefined,
  };
};

export const generateId = () =>
  `id-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`;

export const getVerifierAttributeRequestName = (str: any) => {
  const match = str.match(/\[(.*?)\]$/) || str.match(/\.([^.]+)$/);
  return match ? match[1] : null;
};

export const toggleSpacesAndUnderscores = (str: any, toUnderscore = true) => {
  if (!str) return;
  return toUnderscore ? str.split(" ").join("_") : str.split("_").join(" ");
};

export const wrapIfContainsSpace = (str = "") => {
  return str.includes(" ") ? `["${str}"]` : `.${str}`;
};

export const extractPropertyName = (arr: string[] = []): string | null => {
  if (!Array.isArray(arr) || arr.length === 0) return null;

  const path = arr[0]; // Get the first element
  const match = path.match(/\.([^\.\[\]"]+)|\["(.+?)"\]/g);

  if (!match) return null;

  // Extract the last matched property
  const lastMatch = match[match.length - 1];

  // Clean up the extracted property
  const extracted = lastMatch
    .replace(/^\./, "") // Remove leading dot (.)
    .replace(/\["|"]+/g, "") // Remove brackets and quotes
    .replace(/_/g, " "); // Replace underscores with spaces

  return extracted;
};

// Encrypt using Base64-encoded DER public key
export const encryptWithBase64DerPublicKey = (
  message: any,
  base64DerKey: any
) => {
  // Step 1: Decode Base64 to binary
  const derBytes = forge.util.decode64(base64DerKey);

  // Step 2: Convert binary DER to ASN.1 structure
  const asn1 = forge.asn1.fromDer(derBytes);

  // Step 3: Convert ASN.1 to forge public key object
  const publicKey = forge.pki.publicKeyFromAsn1(asn1);

  // Step 4: Encrypt using RSA-OAEP and SHA-256
  const encrypted = publicKey.encrypt(message, "RSA-OAEP", {
    md: forge.md.sha256.create(),
  });

  // Step 5: Return as Base64
  return forge.util.encode64(encrypted);
};

export async function generateImageWithSmartTextSpacing(
  elements: any,
  variables = {}
) {
  const dpr = window.devicePixelRatio || 1;
  const isAndroid = /Android/i.test(navigator.userAgent);

  if (isAndroid) {
    // Apply Android-specific adjustments
    elements.forEach((el: any) => {
      if (el.fontSize) el.fontSize = el.fontSize * dpr;
      if (el.x) el.x = el.x * dpr;
      if (el.y) el.y = el.y * dpr;
      if (el.width) el.width = el.width * dpr;
      if (el.height) el.height = el.height * dpr;
    });
  }

  // Preprocess elements to flatten groups
  let allElements = [];
  const groupContainers = elements.filter((el: any) => el.isGroup);
  const nonGroupElements = elements.filter((el: any) => !el.isGroup);

  // Add non-group elements
  allElements.push(...nonGroupElements);

  // Create map to preserve group element order
  const groupElementsOrderedMap = new Map();

  // Flatten group elements and attach groupBound
  for (const container of groupContainers) {
    for (const key in container) {
      if (key.startsWith("group:")) {
        const group = container[key];
        if (group.groupData && group.groupBound) {
          // Create ordered array for this group
          const orderedElements = [];

          for (const child of group.groupData) {
            // Attach groupBound to child element
            const childClone = { ...child };
            childClone.groupBound = group.groupBound;
            childClone.groupId = key;
            orderedElements.push(childClone);
            allElements.push(childClone);
          }

          // Store in ordered map preserving original order
          groupElementsOrderedMap.set(key, orderedElements);

          // Add group bound as a special element
          allElements.push({
            ...group.groupBound,
            isGroupBound: true,
            groupId: key,
          });
        }
      }
    }
  }

  // Find background elements from flattened list
  let bgElement = allElements.find((e) => e.id === "bg");
  const otherElements = allElements.filter(
    (e) => e.id !== "bg" && e.id !== "bgColor" && !e.isGroupBound
  );

  if (!bgElement) {
    bgElement = allElements.find((e) => e.id === "bgColor");
  }

  // Create canvas
  const canvas = document.createElement("canvas");
  canvas.width = bgElement.width;
  canvas.height = bgElement.height;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Could not get canvas context");

  // Draw background
  if (bgElement.id === "bg" && bgElement.url) {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = bgElement.url;
    await new Promise((resolve, reject) => {
      img.onload = () => {
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(null);
      };
      img.onerror = reject;
    });
  } else if (bgElement.id === "bgColor" && bgElement.fill) {
    ctx.fillStyle = bgElement.fill;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  // Helper functions
  const getTextMetrics = (ctx: any, text: any, font: any) => {
    ctx.save();
    ctx.font = font;
    const metrics = ctx.measureText(text);
    ctx.restore();
    return {
      width: metrics.width,
      ascent: metrics.actualBoundingBoxAscent || parseInt(font) * 0.8,
      descent: metrics.actualBoundingBoxDescent || parseInt(font) * 0.2,
      height:
        (metrics.actualBoundingBoxAscent || parseInt(font) * 0.8) +
        (metrics.actualBoundingBoxDescent || parseInt(font) * 0.2),
    };
  };

  const getTextWidth = (ctx: any, text: any, letterSpacing: any) => {
    if (letterSpacing === 0) return ctx.measureText(text).width;
    let totalWidth = 0;
    for (let i = 0; i < text.length; i++) {
      totalWidth += ctx.measureText(text[i]).width;
      if (i < text.length - 1) totalWidth += letterSpacing;
    }
    return totalWidth;
  };

  const drawTextWithSpacing = (
    ctx: any,
    text: any,
    x: any,
    y: any,
    letterSpacing: any
  ) => {
    if (letterSpacing === 0) {
      ctx.fillText(text, x, y);
      return;
    }
    let currentX = x;
    for (let i = 0; i < text.length; i++) {
      ctx.fillText(text[i], currentX, y);
      currentX += ctx.measureText(text[i]).width + letterSpacing;
    }
  };

  const replaceVariables = (text: any, vars: any) => {
    if (!text || typeof text !== "string") return text;
    return text.replace(/\{\{([^}]+)\}\}/g, (match, varName) => {
      const trimmedVar = varName.trim();
      return vars.hasOwnProperty(trimmedVar) ? vars[trimmedVar] : match;
    });
  };

  const wrapText = (
    ctx: any,
    text: any,
    maxWidth: any,
    font: any,
    letterSpacing: any
  ) => {
    ctx.save();
    ctx.font = font;

    const words = text.split(" ");
    const lines = [];
    let currentLine = words[0];
    let currentWidth = getTextWidth(ctx, currentLine, letterSpacing);

    for (let i = 1; i < words.length; i++) {
      const word = words[i];
      const wordWidth = getTextWidth(ctx, word, letterSpacing);
      const spaceWidth = getTextWidth(ctx, " ", letterSpacing);
      const potentialWidth = currentWidth + spaceWidth + wordWidth;

      if (potentialWidth <= maxWidth) {
        currentLine += " " + word;
        currentWidth = potentialWidth;
      } else {
        lines.push({ text: currentLine, width: currentWidth });
        currentLine = word;
        currentWidth = wordWidth;
      }
    }

    lines.push({ text: currentLine, width: currentWidth });
    ctx.restore();
    return lines;
  };

  const processTextElement = (ctx: any, el: any, vars: any) => {
    ctx.save();

    // Handle rotation if needed
    if (el.rotation) {
      const centerX = el.x + (el.width || 0) / 2;
      const centerY = el.y + (el.height || 0) / 2;
      ctx.translate(centerX, centerY);
      ctx.rotate((el.rotation * Math.PI) / 180);
      ctx.translate(-centerX, -centerY);
    }

    const originalText = el.text || el.title || "";
    const text = replaceVariables(originalText, vars);
    const fontSize = el.fontSize || 16;
    const fontFamily = el.fontFamily || "Arial";
    const fontWeight = el.fontWeight || "normal";
    const fontStyle = el.fontStyle || "normal";
    const font = `${fontStyle} ${fontWeight} ${fontSize}px ${fontFamily}`;
    const lineHeight = el.lineHeight
      ? el.lineHeight * fontSize
      : fontSize * 1.2;
    const letterSpacing =
      typeof el.letterSpacing !== "undefined" ? el.letterSpacing : 0;
    const shouldUnderline = el.textDecoration === "underline" || el.underline;
    const textAlign = el.textAlign || "left";

    ctx.fillStyle = el.fill || "#000000";
    ctx.font = font;
    ctx.textAlign = textAlign;
    ctx.textBaseline = "alphabetic";

    const metrics = getTextMetrics(ctx, "Hy", font);
    const baselineAdjustment = metrics.ascent;

    // Handle text wrapping
    if (el.width) {
      const lines = wrapText(ctx, text, el.width, font, letterSpacing);
      let yPos = el.y + baselineAdjustment;
      const underlinePositions = [];

      for (const line of lines) {
        let xPos = el.x;
        if (textAlign === "center") {
          xPos = el.x + (el.width - line.width) / 2;
        } else if (textAlign === "right") {
          xPos = el.x + (el.width - line.width);
        }

        drawTextWithSpacing(ctx, line.text, xPos, yPos, letterSpacing);

        if (shouldUnderline) {
          underlinePositions.push({
            x: xPos,
            y: yPos + metrics.descent + 1,
            width: line.width,
          });
        }

        yPos += lineHeight;
      }

      if (shouldUnderline) {
        ctx.strokeStyle = el.fill || "#000000";
        ctx.lineWidth = 1;
        underlinePositions.forEach((pos) => {
          ctx.beginPath();
          ctx.moveTo(pos.x, pos.y);
          ctx.lineTo(pos.x + pos.width, pos.y);
          ctx.stroke();
        });
      }
    } else {
      const totalWidth = getTextWidth(ctx, text, letterSpacing);
      let x = el.x;

      if (textAlign === "center") {
        x = el.x - totalWidth / 2;
      } else if (textAlign === "right") {
        x = el.x - totalWidth;
      }

      drawTextWithSpacing(
        ctx,
        text,
        x,
        el.y + baselineAdjustment,
        letterSpacing
      );

      if (shouldUnderline) {
        const underlineY = el.y + baselineAdjustment + metrics.descent + 1;
        ctx.strokeStyle = el.fill || "#000000";
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(x, underlineY);
        ctx.lineTo(x + totalWidth, underlineY);
        ctx.stroke();
      }
    }

    ctx.restore();
  };

  // Process grouped text elements
  const processGroupedText = (
    ctx: any,
    groupId: any,
    groupBound: any,
    elements: any,
    vars: any
  ) => {
    if (elements.length === 0) return;

    ctx.save();

    // Sort elements by their vertical position (top to bottom)
    const sortedElements = [...elements].sort((a, b) => a.y - b.y);

    // Calculate total height of all text in group
    let totalGroupHeight = 0;
    let maxFontSize = 0;

    // FIRST PASS: calculate heights and replace variables
    for (const el of sortedElements) {
      const fontSize = el.fontSize || 16;
      const lineHeight = el.lineHeight
        ? el.lineHeight * fontSize
        : fontSize * 1.2;

      // Replace variables in text
      const text = replaceVariables(el.text || el.title || "", vars);

      // Calculate text height
      const font = `${el.fontStyle || "normal"} ${el.fontWeight || "normal"} ${fontSize}px ${el.fontFamily || "Arial"}`;
      ctx.font = font;

      let height;
      if (el.width) {
        const lines = wrapText(
          ctx,
          text,
          groupBound.width,
          font,
          el.letterSpacing || 0
        );
        height = lines.length * lineHeight;
      } else {
        height = lineHeight;
      }

      totalGroupHeight += height;
      if (fontSize > maxFontSize) maxFontSize = fontSize;
    }

    // Add spacing between elements
    totalGroupHeight += (sortedElements.length - 1) * (maxFontSize * 0.5);

    // Calculate starting Y position to center vertically
    const startY = groupBound.y + (groupBound.height - totalGroupHeight) / 2;
    let currentY = startY;

    // SECOND PASS: render in vertical order (top to bottom)
    for (const el of sortedElements) {
      const fontSize = el.fontSize || 16;
      const font = `${el.fontStyle || "normal"} ${el.fontWeight || "normal"} ${fontSize}px ${el.fontFamily || "Arial"}`;
      const lineHeight = el.lineHeight
        ? el.lineHeight * fontSize
        : fontSize * 1.2;

      // Replace variables in text
      const text = replaceVariables(el.text || el.title || "", vars);

      // Calculate text height for this element
      let height;
      let lines = [];

      if (el.width) {
        lines = wrapText(
          ctx,
          text,
          groupBound.width,
          font,
          el.letterSpacing || 0
        );
        height = lines.length * lineHeight;
      } else {
        height = lineHeight;
        lines = [
          { text, width: getTextWidth(ctx, text, el.letterSpacing || 0) },
        ];
      }

      // Process each line with center alignment
      ctx.save();
      ctx.fillStyle = el.fill || "#000000";
      ctx.font = font;
      ctx.textAlign = "center";
      ctx.textBaseline = "alphabetic";

      const metrics = getTextMetrics(ctx, "Hy", font);
      const baselineAdjustment = metrics.ascent;
      let yPos = currentY + baselineAdjustment;

      for (const line of lines) {
        const xPos = groupBound.x + groupBound.width / 2;
        drawTextWithSpacing(ctx, line.text, xPos, yPos, el.letterSpacing || 0);
        yPos += lineHeight;
      }

      ctx.restore();

      // Move to next element position
      currentY += height + maxFontSize * 0.5;
    }

    ctx.restore();
  };

  // Group elements by y-position (same line) with tolerance
  const groupElementsByLine = (elements: any) => {
    const lineGroups = {};
    const TOLERANCE = 5; // pixels

    elements.forEach((el: any) => {
      const yPos = Math.round(el.y / TOLERANCE) * TOLERANCE;
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (!lineGroups[yPos]) lineGroups[yPos] = [];
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      lineGroups[yPos].push(el);
    });

    return Object.values(lineGroups);
  };

  // Check if two elements overlap
  const elementsOverlap = (el1: any, el2: any, width1: any, width2: any) => {
    const el1Right = el1.x + width1;
    const el2Left = el2.x;
    return el1Right > el2Left;
  };

  // Separate elements
  const imageElements = otherElements.filter((el) => el.isImage);
  const textElements = otherElements.filter((el) => !el.isImage);
  const nonGroupedTextElements = textElements.filter((el) => !el.groupId);
  const groupedTextElements = textElements.filter((el) => el.groupId);

  // Get unique groups
  const groupBounds = allElements.filter((el) => el.isGroupBound);

  // Draw image elements first
  for (const el of imageElements) {
    if (el.x === undefined || el.y === undefined) continue;

    ctx.save();
    if (el.rotation) {
      const centerX = el.x + (el.width || 0) / 2;
      const centerY = el.y + (el.height || 0) / 2;
      ctx.translate(centerX, centerY);
      ctx.rotate((el.rotation * Math.PI) / 180);
      ctx.translate(-centerX, -centerY);
    }

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = el.url;
    await new Promise((resolve, reject) => {
      img.onload = () => {
        ctx.drawImage(
          img,
          Math.round(el.x),
          Math.round(el.y),
          el.width || img.naturalWidth,
          el.height || img.naturalHeight
        );
        resolve(null);
      };
      img.onerror = reject;
    });
    ctx.restore();
  }

  // Process non-grouped text elements line by line
  const lineGroups = groupElementsByLine(nonGroupedTextElements);

  for (const line of lineGroups as any) {
    // Sort elements by their original x-position to maintain left-to-right order

    line.sort((a: any, b: any) => a.x - b.x);

    const baseY =
      line.reduce((sum: any, el: any) => sum + el.y, 0) / line.length;

    // First pass: calculate metrics for all elements and replace variables
    const elementMetrics = [];
    let totalOriginalWidth = 0;
    let totalReplacedWidth = 0;

    for (const el of line) {
      const originalText = el.text || el.title || "";
      const text = replaceVariables(originalText, variables);
      const font = `${el.fontStyle || "normal"} ${el.fontWeight || "normal"} ${el.fontSize || 16}px ${el.fontFamily || "Arial"}`;
      ctx.font = font;

      const originalWidth = getTextWidth(
        ctx,
        originalText,
        el.letterSpacing || 0
      );
      const replacedWidth = getTextWidth(ctx, text, el.letterSpacing || 0);
      totalOriginalWidth += originalWidth;
      totalReplacedWidth += replacedWidth;

      elementMetrics.push({
        element: el,
        width: el.width ? el.width : replacedWidth,
        font,
        text,
        originalX: el.x,
        originalWidth,
        replacedWidth,
      });
    }

    // Calculate spacing between elements
    const spaceWidth = ctx.measureText(" ").width;
    const adjustedPositions: any = [];
    let totalWidth = 0;
    let needsAdjustment = false;

    // Calculate positions accounting for dynamic width changes

    for (let i = 0; i < line.length; i++) {
      if (i === 0) {
        adjustedPositions[i] = 0;
        totalWidth = elementMetrics[i].replacedWidth;
      } else {
        const prevEl = line[i - 1];

        const currEl = line[i];

        // Calculate original spacing between elements
        const originalSpacing = Math.max(
          0,
          currEl.x - (prevEl.x + elementMetrics[i - 1].originalWidth)
        );

        // Use replaced width for current element
        const newWidth = elementMetrics[i - 1].replacedWidth;

        // Apply spacing - use original spacing plus any extra width from replacement
        adjustedPositions[i] =
          adjustedPositions[i - 1] + newWidth + originalSpacing;
        totalWidth = adjustedPositions[i] + elementMetrics[i].replacedWidth;

        // Check if we need to adjust spacing to prevent overlap
        if (adjustedPositions[i] < adjustedPositions[i - 1] + newWidth) {
          needsAdjustment = true;
        }
      }
    }

    // If we detected potential overlap, use minimum spacing
    if (needsAdjustment) {
      totalWidth = 0;
      const MIN_SPACING = spaceWidth * 1.5;

      for (let i = 0; i < line.length; i++) {
        if (i === 0) {
          adjustedPositions[i] = 0;
          totalWidth = elementMetrics[i].replacedWidth;
        } else {
          adjustedPositions[i] =
            adjustedPositions[i - 1] +
            elementMetrics[i - 1].replacedWidth +
            MIN_SPACING;
          totalWidth = adjustedPositions[i] + elementMetrics[i].replacedWidth;
        }
      }
    }

    // Determine if the original line was centered

    const firstElement = line[0];

    const lastElement = line[line.length - 1];
    const originalLineWidth =
      lastElement.x +
      elementMetrics[line.length - 1].originalWidth -
      firstElement.x;
    const originalLineCenter = firstElement.x + originalLineWidth / 2;
    const canvasCenter = canvas.width / 2;

    const isOriginallyCentered =
      Math.abs(originalLineCenter - canvasCenter) < 10;

    // Calculate starting X position
    let startX = firstElement.x; // Default to original position

    // Only center if the original line was centered
    if (isOriginallyCentered) {
      startX = canvasCenter - totalWidth / 2;
    }

    for (let i = 0; i < line.length; i++) {
      const metrics = elementMetrics[i];
      const adjustedEl = {
        ...metrics.element,
        x: startX + adjustedPositions[i],
        text: metrics.text,
        width: metrics.width,
      };

      processTextElement(ctx, adjustedEl, variables);
    }
    // Draw each element with adjusted positions
  }

  // Process grouped text elements in vertical order (top to bottom)
  for (const bound of groupBounds) {
    const groupId = bound.groupId;
    const groupElements = groupElementsOrderedMap.get(groupId) || [];
    processGroupedText(ctx, groupId, bound, groupElements, variables);
  }

  return new Promise((resolve) => {
    canvas.toBlob(
      (blob) => {
        // @ts-expect-error TS(2345): Argument of type 'Blob | null' is not assignable t... Remove this comment to see the full error message
        resolve(URL.createObjectURL(blob));
      },
      "image/png",
      1
    );
  });
}

export const verifyDocumentWithProof = async (
  document: any,
  proof: any,
  did: any
) => {
  try {
    const res = await GET_PUBLIC_KEY(serialize({ did: did }));
    const { data } = res.data;
    return await verifyProof(document, proof, { contextHashes: {} }, data);
  } catch (error) {
    throw new Error(error instanceof Error ? error.message : String(error));
  }
};

export const cleanObjectKeys = (credentialSubject: any) => {
  const result = {};
  for (const [key, value] of Object.entries(credentialSubject)) {
    // const newKey = key.toLowerCase().replace(/\s+/g, "_");
    const newKey = changeCase.snakeCase(key).toLowerCase();
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    result[newKey] = typeof value === "string" ? value.trim() : value;
  }
  return result;
};

export const commonDateTimeFormats = [
  "M/D/YY HH:mm",
  // Numeric (24-hour) - dash
  "D-M-YYYY HH:mm",
  "D-MM-YYYY HH:mm",
  "DD-M-YYYY HH:mm",
  "DD-MM-YYYY HH:mm",
  "M-D-YYYY HH:mm",
  "MM-D-YYYY HH:mm",
  "M-DD-YYYY HH:mm",
  "MM-DD-YYYY HH:mm",
  "YYYY-M-D HH:mm",
  "YYYY-MM-D HH:mm",
  "YYYY-M-DD HH:mm",
  "YYYY-MM-DD HH:mm",

  // Numeric (24-hour) - slash
  "D/M/YYYY HH:mm",
  "D/MM/YYYY HH:mm",
  "DD/M/YYYY HH:mm",
  "DD/MM/YYYY HH:mm",
  "M/D/YYYY HH:mm",
  "MM/D/YYYY HH:mm",
  "M/DD/YYYY HH:mm",
  "MM/DD/YYYY HH:mm",
  "YYYY/M/D HH:mm",
  "YYYY/MM/D HH:mm",
  "YYYY/M/DD HH:mm",
  "YYYY/MM/DD HH:mm",

  // Numeric (24-hour) - dot
  "D.M.YYYY HH:mm",
  "DD.MM.YYYY HH:mm",
  "M.D.YYYY HH:mm",
  "MM.DD.YYYY HH:mm",
  "YYYY.MM.DD HH:mm",

  // Numeric (24-hour) with seconds
  "D-M-YYYY HH:mm:ss",
  "DD-MM-YYYY HH:mm:ss",
  "D/M/YYYY HH:mm:ss",
  "DD/MM/YYYY HH:mm:ss",
  "YYYY-MM-DD HH:mm:ss",
  "YYYY/MM/DD HH:mm:ss",
  "YYYY.MM.DD HH:mm:ss",

  // Numeric (12-hour with AM/PM)
  "D-M-YYYY h:mm A",
  "DD-MM-YYYY h:mm A",
  "D/MM/YYYY h:mm A",
  "DD/MM/YYYY h:mm A",
  "YYYY-MM-DD h:mm A",
  "YYYY/M/D h:mm A",
  "YYYY/MM/DD h:mm A",
  "YYYY.MM.DD h:mm A",

  // Month name (24-hour)
  "D MMM YYYY HH:mm", // 7 Jun 2026 14:30
  "DD MMM YYYY HH:mm",
  "D MMMM YYYY HH:mm",
  "DD MMMM YYYY HH:mm",
  "MMM D, YYYY HH:mm", // Jun 7, 2026 14:30
  "MMMM D, YYYY HH:mm",
  "MMM DD, YYYY HH:mm",
  "MMMM DD, YYYY HH:mm",
  "YYYY MMM D HH:mm", // 2026 Jun 7 14:30
  "YYYY MMMM D HH:mm",
  "YYYY MMM DD HH:mm",
  "YYYY MMMM DD HH:mm",

  // Month name (12-hour)
  "D MMM YYYY h:mm A",
  "DD MMM YYYY h:mm A",
  "D MMMM YYYY h:mm A",
  "DD MMMM YYYY h:mm A",
  "MMM D, YYYY h:mm A",
  "MMMM D, YYYY h:mm A",
  "MMM DD, YYYY h:mm A",
  "MMMM DD, YYYY h:mm A",
  "YYYY MMM D h:mm A",
  "YYYY MMMM D h:mm A",
  "YYYY MMM DD h:mm A",
  "YYYY MMMM DD h:mm A",

  // ISO fallback
  moment.ISO_8601,
];

export const commonDateFormats = [
  "M/D/YY",

  // Numeric formats with dashes
  "D-M-YYYY",
  "D-MM-YYYY",
  "DD-M-YYYY",
  "DD-MM-YYYY",
  "M-D-YYYY",
  "MM-D-YYYY",
  "M-DD-YYYY",
  "MM-DD-YYYY",

  // Numeric formats with slashes
  "D/M/YYYY",
  "D/MM/YYYY",
  "DD/M/YYYY",
  "DD/MM/YYYY",
  "M/D/YYYY",
  "MM/D/YYYY",
  "M/DD/YYYY",
  "MM/DD/YYYY",
  "YYYY/M/D",
  "YYYY/MM/D",
  "YYYY/M/DD",
  "YYYY/MM/DD",

  // Numeric formats with dots
  "D.M.YYYY",
  "DD.MM.YYYY",
  "M.D.YYYY",
  "MM.DD.YYYY",
  "YYYY.MM.DD",

  // No separator formats
  "YYYYMMDD",
  "DDMMYYYY",
  "MMDDYYYY",

  // ISO numeric formats
  "YYYY-M-D",
  "YYYY-MM-D",
  "YYYY-M-DD",
  "YYYY-MM-DD",

  // Month name formats (day first)
  "D MMM YYYY", // 7 Jun 2026
  "D MMMM YYYY", // 7 June 2026
  "DD MMM YYYY", // 07 Jun 2026
  "DD MMMM YYYY", // 07 June 2026
  "D-MMMM-YYYY", // 7-June-2026
  "DD-MMMM-YYYY", // 07-June-2026

  // Month name formats (month first)
  "MMM D, YYYY", // Jun 7, 2026
  "MMMM D, YYYY", // June 7, 2026
  "MMM DD, YYYY", // Jun 07, 2026
  "MMMM DD, YYYY", // June 07, 2026

  // Reverse readable formats
  "YYYY MMM D", // 2026 Jun 7
  "YYYY MMMM D", // 2026 June 7
  "YYYY MMM DD", // 2026 Jun 07
  "YYYY MMMM DD", // 2026 June 07

  // ISO fallback
  moment.ISO_8601,
];

export const fetchTemplateDesignapi = async (vcdata: any) => {
  try {
    // const verfableCred = [...vcdata];
    return await Promise.all(
      vcdata.map(async (cred: any) => {
        const tempId = cred?.credentialSchema?.id?.split("uuid:")[1];
        if (!tempId) return cred;
        const res = await GET_TEMPLATE_BY_ID(tempId);
        const resData = res.data.data;
        const templateDesigns = resData.templateDesigns;
        let tempDeg: any = [];
        if (templateDesigns.length > 0) {
          const credentialSubject = cleanObjectKeys(cred.credentialSubject);

          const img = await generateImageWithSmartTextSpacing(
            templateDesigns[0].design.metadata,
            credentialSubject
          );
          tempDeg = [img];
        }
        return {
          ...cred,
          templateDesigns:
            tempDeg.length > 0
              ? [
                  {
                    tempDeg,
                    orientation: templateDesigns[0].design.orientation,
                  },
                ]
              : [],
        };
      })
    );
  } catch (error) {
    toast.error(getErrorString(error));
  }
};

export const urlToBase64 = async (url: string): Promise<string | null> => {
  try {
    if (!url) return null;

    // Your actual conversion logic here
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error converting URL to Base64:", error);
    return null;
  }
};

export const toUpperCaseKeys = (input: any) => {
  if (Array.isArray(input)) {
    return input.map((obj) =>
      Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key.toUpperCase(), value])
      )
    );
  } else if (typeof input === "object" && input !== null) {
    return Object.fromEntries(
      Object.entries(input).map(([key, value]) => [key.toUpperCase(), value])
    );
  } else {
    return input; // if it's neither array nor object, return as is
  }
};

export function replaceHandlebarsVar(str: string) {
  return str.replace(/{{\s*(\w+)\s*}}/g, "$1");
}

export async function generateFileHash(content: ArrayBuffer) {
  return crypto.createHash("sha256").update(Buffer.from(content)).digest("hex");
}
